module.exports = __webpack_public_path__ + "static/mack_before-1e7ee79f0ffe019e9698f1e21e01ed45.jpg";